// Models and responses

export interface CdnResponseJSON {
  data: CdnStateJSON;
}

interface CdnStateJSON {
  site_id: string;
  enabled: boolean;
}

export class CdnState {
  public constructor(public siteId: string, public enabled: boolean) {}

  public static fromJSON(json: CdnStateJSON): CdnState {
    return new CdnState(json.site_id, json.enabled);
  }
}
